<script>
  import { modalReservation, User } from "../../store";
  import fetchNodeProduction from "../../helpers/FetchNodeProduction.js";
  import Select from "svelte-select";
  let loading = false;
  export let message;
  export let error;

  let reservation;
  modalReservation.subscribe((value) => {
    reservation = value;
  });
  let statuses = [
    { value: "Confirmed", label: "Confirmed" },
    { value: "Pending", label: "Pending" },
    { value: "Inquiry", label: "Enquiry" },
  ];

  let notValidStatusesForModifications = [
    "Confirmed",
    "Completed",
    "Canceled",
    "Invoice",
  ];
  export let selectedValue = { value: "Confirmed", label: "Confirmed" };
  function handleSelect(event) {
    selectedValue = event.detail;
  }
  function parseMessage(data) {
    const { message } = data;
    if (message == "token expired") {
      User.logout();
    }
    if (message.part1) {
      return `${message.part1 || ""} ${message.part2 || ""} ${
        message.part3 || ""
      } ${message.part4 || ""}`;
    }
    return message;
  }
  async function submitForm() {
    try {
      error = "";
      message = "";
      loading = true;
      const formData = new FormData();
      formData.append("reservationId", reservation.id);
      formData.append("status", selectedValue.value);
      let response = await fetchNodeProduction(
        "/updateReservationStatus",
        formData
      );
      if (typeof response === "object") {
        if (response.status == true) {
          message = parseMessage(response.data);
        } else {
          error = parseMessage(response);
        }
      }
      loading = false;
    } catch (ex) {
      console.log(ex);
    } finally {
      loading = false;
    }
  }
</script>

{#if notValidStatusesForModifications.includes(reservation.status)}
  <small>
    <strong>
      <p class="red-font">[Cannot modify status of a Confirmed reservation]</p>
    </strong>
  </small>
{/if}

<form on:submit|preventDefault={submitForm}>
  <Select
    placeholder="Change status"
    items={statuses}
    {selectedValue}
    on:select={handleSelect}
    isDisabled={notValidStatusesForModifications.includes(reservation.status) ||
      loading}
  />
  <button
    type="submit"
    class="pink-button"
    disabled={notValidStatusesForModifications.includes(reservation.status) ||
      loading}>{loading ? "Loading..." : "Save Changes"}</button
  >
</form>

{#if error}
  <small>
    <strong>
      <p class="red-font">
        {error}
      </p>
    </strong>
  </small>
{/if}
{#if message}
  <small>
    <strong>
      <p class="blue-font">
        {message}
      </p>
    </strong>
  </small>
{/if}
<p class="pink-font">
  <strong>
    Sell Price: ${reservation.sellRate}
  </strong>
</p>
<p class="blue-font">
  <strong>
    {reservation.dateFrom ? reservation.dateFrom.slice(0, 10) : ""} - {reservation.dateTo
      ? reservation.dateTo.slice(0, 10)
      : ""}
  </strong>
  <br />
  {reservation.nights} Nights
</p>
<p>
  <strong>{reservation.guestFirstName} {reservation.guestLastName}</strong>
  <br />
  <strong>{reservation.numberOfGuests} Guests </strong>
  <br />
</p>

<style>
  .pink-button {
    background-color: #ed4368;
    color: #fff;
    margin-top: 10px;
    width: 100%;
  }
  .red-font {
    color: rgb(194, 32, 32);
  }
</style>
